import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SansText } from '../SansText/SansText'
import {
  FrontImageTogglerButton,
  FrontImageTogglerWrapper,
} from './FrontImageToggler.styles'
import type { FrontImageTogglerProps } from './FrontImageToggler.types'

export const FrontImageToggler = ({
  image,
  onToggle,
  productCategory,
}: FrontImageTogglerProps): JSX.Element => {
  const { t } = useTranslation('collection-filters')

  const getCategoryTranslations = useMemo(() => {
    if (!productCategory) {
      return {
        standard: t('imageToggler_view_standard_default'),
        alternative: t('imageToggler_view_alternative_default'),
      }
    }

    const translationKey = `${productCategory}_collection_translation`

    return {
      standard: t(`standard_${translationKey}`),
      alternative: t(`alternative_${translationKey}`),
    }
  }, [productCategory, t])

  return (
    <FrontImageTogglerWrapper>
      <SansText>{t('imageToggler_label')}</SansText>
      <FrontImageTogglerButton
        aria-label={getCategoryTranslations.standard}
        aria-pressed={image === 'standard'}
        active={image === 'standard'}
        onClick={onToggle}
      >
        {getCategoryTranslations.standard}
      </FrontImageTogglerButton>
      <SansText>|</SansText>
      <FrontImageTogglerButton
        aria-label={getCategoryTranslations.alternative}
        aria-pressed={image === 'reverse'}
        active={image === 'reverse'}
        onClick={onToggle}
      >
        {getCategoryTranslations.alternative}
      </FrontImageTogglerButton>
    </FrontImageTogglerWrapper>
  )
}
